import { createContext } from 'react'
import type { ToastItem } from './types'

interface ToastContextValue {
  // Returns the id of the created toast so it can later be updated/dismissed.
  toast: (item: Omit<ToastItem, 'id'>) => string
  // Patch an existing toast in place (e.g. live progress, or swapping a
  // `loading` toast to `success`/`error` when the work finishes).
  update: (id: string, patch: Partial<Omit<ToastItem, 'id'>>) => void
  dismiss: (id: string) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
